import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import fontpage from "../../images/fontpage.jpg";
import logocdac from "../../images/cdac-alt.jpg";
import title from "../../images/Diginyay-transparent.png";
import logo from "../../images/main-logo.png";
import front from "../../images/FRONTPAGES/CDAC FRONT SOCIAL MEDIA.png";

import {
  countPlatforms,
  countSections,
  countSentiment,
  countLanguages,
  addFontsToPDF, //language fonts
} from "./Pdfhelper";

export const PrintReport = async (
  serverresponse,
  analyticsData,
  pieChartRef,
  sectionPieChartRef,
  sentimentPieChartRef,
  selectedPlatforms,
  barChartRef,
  wordCloudRef,
  setIsCompleted,
  setIsLoading,
  pdfToSimple,
  pdfFromSimple
) => {
  setIsLoading(true); // Show loading indicator
  //
  //

  try {
    const pdf = new jsPDF("p", "mm", "a4");

    // const pdf = new jsPDF({
    //   format: "a4",
    //   unit: "mm", // Ensure dimensions are in millimeters
    // });

    // Function to add background image
    const addBackgroundImage = (pdfInstance) => {
      const imgWidth = pdfInstance.internal.pageSize.getWidth();
      const imgHeight = pdfInstance.internal.pageSize.getHeight();
      pdfInstance.addImage(fontpage, "JPEG", 0, 0, imgWidth, imgHeight);
    };

    // Add background image to the first page
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = pdf.internal.pageSize.getHeight();
    pdf.addImage(front, "JPEG", 0, 0, imgWidth, imgHeight);

    const titleImgWidth = 100; // Set your title image width
    const titleImgHeight = 30; // Set your title image height
    const pageWidth = pdf.internal.pageSize.getWidth();
    const titleImgX = (pageWidth - titleImgWidth) / 2;
    const titleImgY = 50; // Set the desired Y position of the title image

    // pdf.addImage(
    //   title,
    //   "JPEG",
    //   titleImgX,
    //   titleImgY,
    //   titleImgWidth,
    //   titleImgHeight
    // );

    // const logoImgWidth = 70; // Set your logo image width
    // const logoImgHeight = 70; // Set your logo image height
    // const logoImgX = (pageWidth - logoImgWidth) / 2;
    // const logoImgY = titleImgY + titleImgHeight + 5; // Position the logo 10mm below the title image

    // pdf.addImage(logo, "JPEG", logoImgX, logoImgY, logoImgWidth, logoImgHeight);

    // Set the text color and font size
    pdf.setTextColor(255, 255, 255);

    pdf.setFontSize(26);

    // const platformLabel =
    //   selectedPlatforms.length === 0
    //     ? "Consolidated Report"
    //     : selectedPlatforms[0].label;
    // pdf.text(platformLabel, 61, 175);

    // console.log("selectedPlatforms", selectedPlatforms[0].label)

    // Add the "CENTRE FOR DEVELOPMENT OF ADVANCED COMPUTING" text below "Analysis Report"
    // const centreTextY = analysisReportY + 10; // Adjust the Y-coordinate as needed
    // pdf.text("CENTRE FOR DEVELOPMENT OF ADVANCED COMPUTING", 10, centreTextY);

    if (pdfToSimple) {
      pdf.setFont(undefined, "bold"); // Keep the default font but make it bold
      pdf.text(`  ${pdfToSimple}`, 41, 213); // Position the text as specified
    }

    // Ensure the pieChartRef exists and draw pie charts on the second page
    if (
      pieChartRef.current &&
      sectionPieChartRef.current &&
      sentimentPieChartRef.current
    ) {
      pdf.addPage();

      addBackgroundImage(pdf);

      const pieChartCanvas = await html2canvas(pieChartRef.current);
      const pieChartImage = pieChartCanvas.toDataURL("image/jpeg");
      const sectionPieChartCanvas = await html2canvas(
        sectionPieChartRef.current
      );
      const sectionPieChartImage =
        sectionPieChartCanvas.toDataURL("image/jpeg");

      const sentimentPieChartCanvas = await html2canvas(
        sentimentPieChartRef.current
      );
      const sentimentPieChartImage =
        sentimentPieChartCanvas.toDataURL("image/jpeg");

      // Get the width and height of the canvas to maintain aspect ratio
      const imgWidth = 295;
      const aspectRatio = pieChartCanvas.width / pieChartCanvas.height;
      const imgHeight = imgWidth / aspectRatio;

      // Calculate starting x-coordinate to center the pie chart horizontally
      const startX = (pdf.internal.pageSize.getWidth() - imgWidth) / 2;

      // Draw platform pie chart and its counts
      pdf.addImage(pieChartImage, "JPEG", startX, 5, imgWidth, imgHeight);

      const languagesCounts = countLanguages(serverresponse, analyticsData);
      let platformCountText = "\n";
      for (const platform in languagesCounts) {
        platformCountText += `${platform}: ${languagesCounts[platform]}, `;
      }

      const wrappedPlatformCountText = pdf.splitTextToSize(
        platformCountText,
        pdf.internal.pageSize.getWidth() + 135
      );

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(0, 123, 255);
      pdf.text("Language Count:", 10, imgHeight + 15);

      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.text(wrappedPlatformCountText, 10, imgHeight + 15);

      // Draw sentiment pie chart and its counts
      pdf.addImage(
        sentimentPieChartImage,
        "JPEG",
        startX,
        imgHeight + imgHeight + 65,
        imgWidth,
        imgHeight
      );
      const sentimentCounts = countSentiment(serverresponse, analyticsData);
      let sentimentCountText = "\n";
      for (const sentiment in sentimentCounts) {
        sentimentCountText += `${sentiment}: ${sentimentCounts[sentiment]}, `;
      }
      const wrappedSentimentCountText = pdf.splitTextToSize(
        sentimentCountText,
        pdf.internal.pageSize.getWidth() - 20
      );

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(0, 123, 255); // #007bff color for Sentiment Counts heading
      pdf.text("Sentiment Count:", 10, imgHeight + imgHeight + imgHeight + 75);

      // pdf.setFont("helvetica", "normal");

      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.text(
        wrappedSentimentCountText,
        10,
        imgHeight + imgHeight + imgHeight + 75
      );

      // Draw section pie chart and its counts
      const sectionPieChartWidth = 290; // Customize this value as needed
      const sectionPieChartHeight = 90; // Customize this value as needed

      pdf.addImage(
        sectionPieChartImage,
        "JPEG",
        startX,
        imgHeight + 25,
        sectionPieChartWidth,
        sectionPieChartHeight
      );

      const sectionCounts = countSections(serverresponse, analyticsData);
      let sectionCountText = "\n";
      for (const section in sectionCounts) {
        sectionCountText += `${section}: ${sectionCounts[section]}, `;
      }

      const wrappedSectionCountText = pdf.splitTextToSize(
        sectionCountText,
        pdf.internal.pageSize.getWidth() - 20
      );

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(0, 123, 255); // #007bff color for Sentiment Count
      pdf.text("Section Count:", 10, imgHeight + imgHeight + 55);

      // pdf.setFont("helvetica", "normal");

      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.text(wrappedSectionCountText, 10, imgHeight + imgHeight + 57);
    } else {
      console.error("Pie chart reference not found or not rendered.");
    }

    // Add a third page for the word cloud and bar chart
    if (barChartRef.current) {
      pdf.addPage();
      addBackgroundImage(pdf);
      const topMargin = 3;
      const bottomMargin = 30;

      // Draw white background rectangle for bar chart with space from top and bottom
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const usableHeight = pageHeight - topMargin - bottomMargin;
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, topMargin, pageWidth, usableHeight, "F");

      // Draw bar chart
      const barChartCanvas = await html2canvas(barChartRef.current);
      const barChartImage = barChartCanvas.toDataURL("image/jpeg");

      const barChartWidth = pageWidth - 30; // full width with padding
      const barChartAspectRatio = barChartCanvas.width / barChartCanvas.height;
      const barChartHeight = barChartWidth / barChartAspectRatio;

      const barChartStartX = (pageWidth - barChartWidth) / 2;

      const barChartStartY = topMargin + 10;

      // Draw bar chart
      pdf.addImage(
        barChartImage,
        "JPEG",
        barChartStartX,
        barChartStartY,
        barChartWidth,
        barChartHeight
      );

      const languagesCounts = countPlatforms(serverresponse, analyticsData);
      let platformCountText = "Platform Counts:\n";
      for (const platform in languagesCounts) {
        platformCountText += `${platform}: ${languagesCounts[platform]}, `;
      }
      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.text(platformCountText, 10, barChartHeight + 20);

      if (wordCloudRef.current) {
        const wordCloudCanvas = await html2canvas(wordCloudRef.current);
        const wordCloudImage = wordCloudCanvas.toDataURL("image/jpeg");

        // Set a specific width for the word cloud image
        const wordCloudWidth = 200;
        const wordCloudAspectRatio =
          wordCloudCanvas.width / wordCloudCanvas.height;
        const wordCloudHeight = wordCloudWidth / wordCloudAspectRatio;

        const wordCloudStartX = (pageWidth - wordCloudWidth) / 2;
        const wordCloudStartY = barChartStartY + barChartHeight + 25;

        pdf.addImage(
          wordCloudImage,
          "JPEG",
          wordCloudStartX,
          wordCloudStartY,
          wordCloudWidth,
          wordCloudHeight
        );
      }
    } else {
      console.error("Bar chart reference not found or not rendered.");
    }

    // Start table from the next page
    pdf.addPage();

    const tableData = serverresponse || analyticsData;

    if (!tableData || tableData.length === 0) {
      console.error("No data available to print");
      return;
    }

    const tableColumnHeaders = [
      "S.No",
      "UserName",
      "Language",
      "Section",

      "Platform",
      "Content",
      "Translation",
    ];

    const tableRows = tableData
      .filter((data) => data.languages !== "none")
      .map((data, index) => {
        //

        const truncateContent = (content, wordLimit) => {
          if (typeof content !== "string") {
            return "N/A";
          }
          const words = content.split(" ");
          if (words.length > wordLimit) {
            return words.slice(0, wordLimit).join(" ") + "...";
          }
          return content;
        };

        return [
          String(index + 1),
          data.userId ? String(data.userId) : String(data.postOwner || "N/A"),
          String(data.languages || "N/A"),
          data.sections && data.sections.length > 0
            ? data.sections.map((section) => String(section)).join(", ")
            : "N/A",

          String(data.platform || "N/A"),
          {
            content:
              data.platform === "YOUTUBE"
                ? truncateContent(data.title, 30)
                : truncateContent(data.content, 30) || "N/A",
            link: data.link,
          },

          data.platform === "YOUTUBE"
            ? String(truncateContent(data.titleTranslation || "N/A", 30))
            : String(truncateContent(data.translation || "N/A", 30)),
        ];
      });

    // Log the prepared table rows to ensure all data is in the correct format
    //
    //
    pdf.autoTable({
      head: [tableColumnHeaders],
      body: tableRows,
      startY: 10,
      tableWidth: "auto",
      styles: {
        cellPadding: 2,
        fontSize: 10,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [0, 0, 0],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
      },
      bodyStyles: {
        textColor: [0, 0, 0],
      },
      alternateRowStyles: {
        fillColor: [227, 242, 253],
      },
      columnStyles: {
        0: { cellWidth: 12 },
        1: { cellWidth: 23 },
        2: { cellWidth: 21 },
        3: { cellWidth: 20 },

        4: { cellWidth: 21 },
        5: { cellWidth: 55 },
        6: { cellWidth: 55 },
      },

      margin: { top: 1, left: 1, right: 1, bottom: 1 },

      didParseCell: function (data) {
        if (data.column.index === 6 && data.cell.section === "body") {
          data.cell.styles.cellPadding = 2;
        }
      },

      didDrawCell: function (data) {
        if (data.cell.section === "body" && data.cell.raw) {
          const cell = data.cell;
          const pdfDoc = data.doc;
          const cellWidth =
            cell.width - cell.padding("left") - cell.padding("right");
          const textPos = {
            x: cell.x + cell.padding("left"),
            y: cell.y + cell.padding("top") + 2,
          };

          if (data.column.index === 1 && cell.raw) {
            //
            pdfDoc.setFontSize(10);
            pdfDoc.setTextColor(0, 0, 0);
            const splitText = pdfDoc.splitTextToSize(cell.raw, cellWidth);
            const lineSpacing = 4;

            splitText.forEach((line, index) => {
              //
              let fontForThisLine = "NotoSans"; // Default font

              if (/\p{Script=Devanagari}/u.test(line)) {
                addFontsToPDF(pdf, "Hindi");
                fontForThisLine = "NotoSans";
              } else if (/\p{Script=Tamil}/u.test(line)) {
                addFontsToPDF(pdf, "Tamil");
                fontForThisLine = "NotoSansTamil";
              } else if (/\p{Script=Gujarati}/u.test(line)) {
                addFontsToPDF(pdf, "Gujarati");
                fontForThisLine = "NotoSansGujarati";
              } else if (/\p{Script=Bengali}/u.test(line)) {
                addFontsToPDF(pdf, "Bengali");
                fontForThisLine = "NotoSansBengali";
              } else if (/\p{Script=Gurmukhi}/u.test(line)) {
                addFontsToPDF(pdf, "Punjabi");
                fontForThisLine = "NotoSansGurmukhi"; // For Punjabi (Gurmukhi script)
              } else if (/\p{Script=Arabic}/u.test(line)) {
                addFontsToPDF(pdf, "Urdu");
                fontForThisLine = "NotoSansArabic";
              } else if (/\p{Script=Malayalam}/u.test(line)) {
                addFontsToPDF(pdf, "Malayalam");
                fontForThisLine = "NotoSansMalayalam";
              } else if (/\p{Script=Oriya}/u.test(line)) {
                addFontsToPDF(pdf, "Oriya");
                fontForThisLine = "NotoSansOriya";
              } else if (/\p{Script=Kannada}/u.test(line)) {
                addFontsToPDF(pdf, "Kannada");
                fontForThisLine = "NotoSerifKannada";
              }

              pdf.setFont(fontForThisLine);
              pdfDoc.text(line, textPos.x, textPos.y + index * lineSpacing);
            });
          }

          if (data.column.index === 6 && cell.raw) {
            //
            pdfDoc.setFontSize(10);
            pdfDoc.setTextColor(0, 0, 0);
            const splitText = pdfDoc.splitTextToSize(cell.raw, cellWidth);
            const lineSpacing = 4;
            splitText.forEach((line, index) => {
              //
              let fontForThisLine = "NotoSans"; // Default font

              if (/\p{Script=Devanagari}/u.test(line)) {
                addFontsToPDF(pdf, "Hindi");
                fontForThisLine = "NotoSans";
              } else if (/\p{Script=Tamil}/u.test(line)) {
                addFontsToPDF(pdf, "Tamil");
                fontForThisLine = "NotoSansTamil";
              } else if (/\p{Script=Gujarati}/u.test(line)) {
                addFontsToPDF(pdf, "Gujarati");
                fontForThisLine = "NotoSansGujarati";
              } else if (/\p{Script=Oriya}/u.test(line)) {
                addFontsToPDF(pdf, "Oriya");
                fontForThisLine = "NotoSansOriya";
              } else if (/\p{Script=Bengali}/u.test(line)) {
                addFontsToPDF(pdf, "Bengali");
                fontForThisLine = "NotoSansBengali";
              } else if (/\p{Script=Gurmukhi}/u.test(line)) {
                addFontsToPDF(pdf, "Punjabi");
                fontForThisLine = "NotoSansGurmukhi"; // For Punjabi (Gurmukhi script)
              } else if (/\p{Script=Arabic}/u.test(line)) {
                addFontsToPDF(pdf, "Urdu");
                fontForThisLine = "NotoSansArabic";
              } else if (/\p{Script=Malayalam}/u.test(line)) {
                addFontsToPDF(pdf, "Malayalam");

                fontForThisLine = "NotoSansMalayalam";
              } else if (/\p{Script=Kannada}/u.test(line)) {
                addFontsToPDF(pdf, "Kannada");
                fontForThisLine = "NotoSerifKannada";
              }
              pdf.setFont(fontForThisLine);
              pdfDoc.text(line, textPos.x, textPos.y + index * lineSpacing);
            });
          }

          if (data.column.index === 5 && cell.raw.link) {
            pdfDoc.setFontSize(10);
            pdfDoc.setTextColor(0, 0, 0);
            const splitText = pdfDoc.splitTextToSize(
              cell.raw.content,
              cellWidth
            );
            const lineSpacing = 4;

            splitText.forEach((line, index) => {
              //
              let fontForThisLine = "NotoSans"; // Default font

              if (/\p{Script=Devanagari}/u.test(line)) {
                addFontsToPDF(pdf, "Hindi");
                fontForThisLine = "NotoSans";
              } else if (/\p{Script=Oriya}/u.test(line)) {
                addFontsToPDF(pdf, "Oriya");
                fontForThisLine = "NotoSansOriya";
              } else if (/\p{Script=Gujarati}/u.test(line)) {
                addFontsToPDF(pdf, "Gujarati");
                fontForThisLine = "NotoSansGujarati";
              } else if (/\p{Script=Tamil}/u.test(line)) {
                addFontsToPDF(pdf, "Tamil");
                fontForThisLine = "NotoSansTamil";
              } else if (/\p{Script=Bengali}/u.test(line)) {
                addFontsToPDF(pdf, "Bengali");
                fontForThisLine = "NotoSansBengali";
              } else if (/\p{Script=Gurmukhi}/u.test(line)) {
                addFontsToPDF(pdf, "Punjabi");
                fontForThisLine = "NotoSansGurmukhi"; // For Punjabi (Gurmukhi script)
              } else if (/\p{Script=Arabic}/u.test(line)) {
                addFontsToPDF(pdf, "Urdu");

                fontForThisLine = "NotoSansArabic";
              } else if (/\p{Script=Malayalam}/u.test(line)) {
                addFontsToPDF(pdf, "Malayalam");

                fontForThisLine = "NotoSansMalayalam";
              } else if (/\p{Script=Kannada}/u.test(line)) {
                addFontsToPDF(pdf, "Kannada");
                fontForThisLine = "NotoSerifKannada";
              }
              pdf.setFont(fontForThisLine);

              pdfDoc.textWithLink(
                line,
                textPos.x,
                textPos.y + index * lineSpacing,
                { url: cell.raw.link }
              );
            });
          }
        }
      },

      willDrawCell: function (data) {
        if (
          data.column.index === 5 &&
          data.cell.section === "body" &&
          data.cell.raw
        ) {
          const cell = data.cell;
          cell.text = "";
        }

        if (
          data.column.index === 1 &&
          data.cell.section === "body" &&
          data.cell.raw
        ) {
          const cell = data.cell;
          cell.text = "";
        }

        if (
          data.column.index === 6 &&
          data.cell.section === "body" &&
          data.cell.raw
        ) {
          const cell = data.cell;
          cell.text = "";
        }
      },

      rowPageBreak: "avoid",
    });

    const platformLabels =
      selectedPlatforms.length === 0
        ? "Consolidated"
        : selectedPlatforms[0].label;
    if (pdfToSimple) {
      pdf.save(
        `CSMART_${platformLabels}_Social_Media_Report_${pdfToSimple}.pdf`
      );
      setIsCompleted(true);
    } else {
      pdf.save(`CSMART_${platformLabels}_Report.pdf`);
      setIsCompleted(true);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
  setIsLoading(false);
};
